module.exports = __webpack_public_path__ + "img/人资圈.da482d9c.png";